import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import AddIcon from '@mui/icons-material/Add'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import DialogTable from '../payment-partners/dialog-table'
import DialogFormTariff from '../payment-partners/dialog-tariff'
import { useGetTariffQuery } from '../payment-partners/tariff-api'
import { useSelector } from 'react-redux';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import WidgetPaper from '@/components/WidgetPaper'
import TableEmptyPlaceholder from '@/components/TableEmptyPlaceholder'
import useLayout from '@/features/layout/useLayout'
import IconButton from '@mui/material/IconButton'

const Tariffs = ({ ref }) => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { t } = useTranslation()
  const { isMobile } = useLayout()
  const { data, isSuccess, isError, isLoading } = useGetTariffQuery(activeBuildingId)
  const [openModal, setOpenModal] = useState(false)
  const emptyPlaceholder = `${t('list_empty')}\n${t('tariffs-list_explained')}`
  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  return (
    <>
      <WidgetPaper
        ref={ref}
        title={t('rates')}
      >
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
            mb: 2
          }}>
          {isMobile ? (
            <IconButton
              color="primary"
              size="small"
              onClick={handleOpenModal}
            >
              <AddIcon />
            </IconButton>
          ) : (
            <Button
              color="primary"
              startIcon={<AddIcon />}
              variant="outlined"
              size="small"
              onClick={handleOpenModal}
            >
              {t('create_a_tariff')}
            </Button>
          )}
        </Stack>
        <Stack>
          <DialogTable
            tariffs={data || []}
            buildingId={activeBuildingId}
            isLoading={isLoading}
          />
        </Stack>
        {
          !data?.length && isSuccess && !isLoading && (
          <TableEmptyPlaceholder
            icon={LocalOfferIcon}
            message={emptyPlaceholder}
          />
        )}
        {
          isError && (
          <Alert severity="error" sx={{ mt: 3 }}>
            <AlertTitle>{t('alert')}</AlertTitle>
            {t('error_occurred')}
          </Alert>
        )}
      </WidgetPaper>
      <DialogFormTariff
        open={openModal}
        onClose={handleCloseModal}
        buildingId={activeBuildingId}
      />
    </>
  );
};

export default Tariffs
